import { render } from "./BrandDebugBanner.vue?vue&type=template&id=fb11cacc&scoped=true"
import script from "./BrandDebugBanner.vue?vue&type=script&lang=js"
export * from "./BrandDebugBanner.vue?vue&type=script&lang=js"

import "./BrandDebugBanner.vue?vue&type=style&index=0&id=fb11cacc&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb11cacc"]])

export default __exports__